module.exports = __webpack_public_path__ + "static/media/32.7bc9876f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/32.jpg
// module id = 401
// module chunks = 0